import React from 'react'
import styled from 'styled-components'

import { Box, Button } from '@usap/uicomponents'

const borderColor = props => props.theme.global.colors['background-back']
const whiteColor = props => props.theme.global.colors.white
const border2Color = props => props.theme.global.colors['border-2']

export const OrderESPPContainer = styled(Box)`
  background: ${whiteColor};
  border: solid 1px ${borderColor};
  border-radius: 4px;
  margin-bottom: 16px;
`

export const OrderESPPFrame = styled(Box)`
  flex-direction: column;
  padding: 16px;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: row;
    justify-content: space-between;
    padding: 24px;
  }
`

export const OrderItemESPPBox = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 32px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 65%;
  }
`

export const OrderESPPDivider = styled.div`
  display: none;
  border: 0.5px solid #D4D4D6;
  margin: 0px 32px;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    display: inherit;
  }
`

export const OrderESPPButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  flex: 1;
`

export const OrderESPPDetailsButtonContainer = styled(Box)`
  width: 100%;
`

export const OrderESPPDetailsClaimButton = styled(Button)`
  width: 100%;
  height: 40px;
  background-color: ${whiteColor};
  border: 1px solid ${border2Color};
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;

  :hover {
    background-color: ${whiteColor};
  }

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`

export const OrderESPPImageContainer = styled(Box)`
  gap: 12px;
`
export const OrderESPPImage = styled.img`
  height: 108px;
  position: relative;
  width: 108px;
  border: 1.50px #D4D4D6 solid;
`
export const OrderESPPDetailsContainer = styled(Box)`
  padding: 8px;
`

export const OrderDetailESPPContainer = styled(Box)`
  flex: 1 0 0;
  padding: 8px;
`

export const OrderESPPTitle = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
`

export const OrderESPPExtendPackage = styled.p`
  align-self: stretch;
  color: #282832;
  font-family: "Roboto-SemiBold", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 26.4px;
  margin-top: -1px;
  position: relative;
`

export const OrderESPPSpan = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 165%;
  color: #282832;
`

export const OrderESPPTextWrapper2 = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 165%;
  color: #282832;
`

export const OrderESPPLabelSkuInfoWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 3px;
  width: 508px;
  height: 23px;
`
export const OrderESPPLabelSkuInfo = styled.p`
color: #282832;
font-family: "Roboto-Regular", Helvetica;
font-size: 14px;
font-weight: 400;
letter-spacing: 0;
line-height: 23.1px;
margin-top: -1px;
position: relative;
white-space: nowrap;
width: fit-content;
`

export const OrderESPPTextWrapper3 = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 165%;
  color: #282832;
`

export const OrderESPPTextWrapper4 = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 165%;
  color: #282832;
`

export const OrderESPPParagraph = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 165%;

  color: #282832;
  position: relative;
  white-space: normal;
  width: fit-content;
`
